import { Box, Typography, List, ListItem, Divider, Link } from "@mui/material";

import { contacts, workingHours } from "@/utils/staticData/contacts";
import Socials from "./Socials";

const Contacts = () => {
  return (
    <Box>
      <Typography variant="h4" component="h3" mb={2}>
        Contact Info
      </Typography>
      <List
        disablePadding
        sx={{
          mb: { xs: 3, md: 4 },
          "& li:not(:last-of-type)": {
            mb: { xs: 1, md: 3 },
          },
        }}
      >
        {contacts.map(({ type, Icon, value, label }, index) => (
          <ListItem key={index} disablePadding>
            <Icon color="primary" sx={{ mr: 2 }} />
            <Link
              href={
                type === "email"
                  ? `mailto:${value}`
                  : type === "phone"
                  ? `tel:${value}`
                  : `${value}`
              }
              underline="hover"
            >
              <Typography
                variant="subtitle1"
                component="span"
                sx={{ fontSize: 18 }}
              >
                {label}
              </Typography>
            </Link>
          </ListItem>
        ))}
      </List>
      <Divider />

      <Typography variant="h4" component="h3" mb={2} mt={{ xs: 3, lg: 4.5 }}>
        Working hours
      </Typography>
      <List disablePadding sx={{ mb: { xs: 3, lg: 4 } }}>
        {workingHours.map(({ value }, index) => (
          <ListItem key={index} disablePadding>
            <Typography
              variant="subtitle1"
              component="span"
              sx={{ fontSize: 18 }}
            >
              {value}
            </Typography>
          </ListItem>
        ))}
      </List>
      <Divider />

      <Typography variant="h4" component="h3" mb={2} mt={{ xs: 3, lg: 4.5 }}>
        We are here!
      </Typography>

      <Typography
        variant="subtitle1"
        component="p"
        color="text.secondary"
        sx={{ fontSize: 18 }}
        mb={{ xs: 3, lg: 5 }}
      >
        Get answers, feedback and learn how Trackmate work.
      </Typography>
       <Socials />
    </Box>
  );
};

export default Contacts;
